import { getEnv } from "@yuntoo/fetch";

/**
 * 判断当前是否在 iframe 中运行
 * @returns boolean
 */
export const isInIframe = () => {
  return window.parent !== window;
};

/**
 * 向 Lovrabet 工作台发送 postMessage 消息的方法
 * 用于在工作台中iframe潜入运行态使用的场景
 * @param data
 */
export const postMessageToWorkbench = (data: { action: string; data: any }) => {
  // 未被嵌入的场景不发送
  if (
    !isInIframe() ||
    !data ||
    typeof window.parent.postMessage !== "function"
  ) {
    return;
  }

  // 合并 message
  const message = {
    type: "RUNTIME_MESSAGE",
    ...data,
  };

  // 根据不同的环境设置不同的 targetOrigin
  const targetOrigin =
    getEnv() !== "online"
      ? "https://daily.lovrabet.com/"
      : "https://app.lovrabet.com/";
  window.parent.postMessage(message, targetOrigin);

  // TODO: 如果在日常环境, 给dev本地环境也发送一次, 方便调试
  if (getEnv() === "daily") {
    window.parent.postMessage(message, "https://dev.lovrabet.com:5200/");
  }
};
